module.exports = __webpack_public_path__ + "static/tild3139-6535-4361-b363-326635353530__4_forbes-7d481a8f30cc941cecdc3910c7535806.webp";